import React from 'react';

const Heading = ({ content }) => {
	if (!content) {
		return null;
	}

	return (
		<h2 className="text-title-sm md:text-base md:leading-tight" itemProp="name">
			{content}
		</h2>
	);
};

export default Heading;
